import React from 'react';
import './Packages.css';

const packages = [
  {
    description: "Perfect for couples, portraits, or creative concepts in natural light.",
    price: "৳3,500",
  },
  {
    description: "Coverage for birthdays, engagements, corporate and personal events.",
    price: "৳5,000",
  },
  {
    description: "Professional team, office environment, and profile shoots.",
    price: "৳4,500",
  },
  {
    description: "Full-day wedding coverage with cinematic edits and storytelling moments.",
    price: "৳12,000",
  },
  {
    description: "Studio or lifestyle setups tailored for e-commerce and catalogs.",
    price: "৳2,500",
  },
];

const Packages = () => {
  return (
    <div className="packages-page">
      <div className="packages-header">
        <span className="emoji">📦</span>
        <h1>Our Photography Packages</h1>
        <p>Choose a package that suits your story. All prices are customizable upon discussion.</p>
      </div>

      <div className="packages-grid">
        {packages.map((item, i) => (
          <div className="package-card" key={i}>
            <p className="package-description">{item.description}</p>
            <p className="package-price">Starts at <strong>{item.price}</strong></p>
            <a href="/book" className="book-button">Book Now</a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Packages;
